import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import countryService from "../services/countryService";

const countriesCollectionName = "countries";

export const useCountry = () => {
  return useQuery({
    queryKey: [countriesCollectionName],
    queryFn: () => countryService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddCountry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: countryService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [countriesCollectionName] });
    },
  });
};

export const useEditCountry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: countryService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [countriesCollectionName] });
    },
  });
};

export const useDeleteCountry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: countryService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [countriesCollectionName] });
    },
  });
};

export const useCountryNameById = (countryId) => {
  return useQuery({
    queryKey: [countriesCollectionName, countryId],
    queryFn: () => countryService.getNameById(countryId),
    enabled: !!countryId, // only run when countryId is truthy
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const useCountryIdByName = (countryName) => {
  return useQuery({
    queryKey: [countriesCollectionName, countryName],
    queryFn: () => countryService.getIdByName(countryName),
    enabled: !!countryName, // only run when countryName is truthy
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useCountryByName = (countryName) => {
  return useQuery({
    queryKey: [countriesCollectionName, "byName", countryName],
    queryFn: () => countryService.getByName(countryName),
    enabled: !!countryName, // only run when countryName is truthy
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
